import styled from 'styled-components';

export const Card = styled.div`
  border: 1px solid var(--border-default);
  border-radius: var(--border-radius-small);
  padding: var(--spacing-x-large);
`;

export const Image = styled.img``;
